export const fileSizeError = 'Attachment file exceeds maximum size limit of 10.00 MB'
export const fileFormatError = 'Only files with the following extensions are allowed: jpg, png, zip, pdf, doc, xls'
export const confirmEmailSendSuccess = 'Thank you! The form has been successfully submitted. We will be in touch shortly.'
export const confirmShowreelLinkCopied = 'Showreel url has been copied to clipboard'
